module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('textarea', {
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.content))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-84b10dec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/form/Tinymce.vue
// module id = 775
// module chunks = 2